import { PayloadAction, ReducerCreators } from '@reduxjs/toolkit';

import { IProjectStats, ISessionStats, IStatsState } from './types';
import createEmptyProjectStats from './helpers/create-empty-project-stats';
import createEmptySessionStats from './helpers/create-empty-session-stats';
import { IStatsWrapper } from '@/types/analytics';

export const reducers = (create: ReducerCreators<IStatsState>) => ({
  updateFetchedProjectStats: create.reducer(
    (state, action: PayloadAction<{ projectUuid: string; key: keyof IProjectStats } & Partial<IStatsWrapper>>) => {
      const { key, projectUuid, ...rest } = action.payload;
      if (!state.projectStats[projectUuid]) {
        state.projectStats[projectUuid] = createEmptyProjectStats();
      }
      state.projectStats[projectUuid] = {
        ...state.projectStats[projectUuid],
        [key]: {
          ...state.projectStats[projectUuid][key],
          ...rest,
        },
      };
    }
  ),
  updateFetchedSessionStats: create.reducer(
    (state, action: PayloadAction<{ sessionUuid: string; key: keyof ISessionStats } & Partial<IStatsWrapper>>) => {
      const { key, sessionUuid, ...rest } = action.payload;

      if (!state.sessionStats[sessionUuid]) {
        state.sessionStats[sessionUuid] = createEmptySessionStats();
      }

      state.sessionStats[sessionUuid] = {
        ...state.sessionStats[sessionUuid],
        [key]: {
          ...state.sessionStats[sessionUuid][key],
          ...rest,
        },
      };
    }
  ),
  clearAllProjectStats: create.reducer((state) => {
    state.projectStats = {};
  }),
  clearAllSessionStats: create.reducer((state) => {
    state.sessionStats = {};
  }),
});
